export type LegalDocId = 'privacy' | 'terms';

export type LegalDoc = {
  id: LegalDocId;
  title: string;
  updated: string;
  sections: { heading: string; body: string }[];
};

export const legalDocs: LegalDoc[] = [
  {
    id: 'privacy',
    title: 'Privacy Policy',
    updated: 'October 5, 2026',
    sections: [
      {
        heading: 'Information we collect',
        body: 'When you call, text, or request a free estimate, we may collect your name, phone number, email address, property address, and details about the work you need. We do not collect payment information through this website.',
      },
      {
        heading: 'How we use your information',
        body: 'We use your information only to contact you about your estimate, schedule and complete services, send invoices, and follow up on our work. We never sell or rent your personal information to third parties.',
      },
      {
        heading: 'Sharing',
        body: 'We may share limited information with trusted vendors who help us run our business (such as scheduling or invoicing tools), and only as needed to provide our services. We may also disclose information if required by law.',
      },
      {
        heading: 'Photos of your property',
        body: 'With your permission, we may take before-and-after photos of completed work. We will never publish your address or any personally identifying details without your written consent.',
      },
      {
        heading: 'Data retention & security',
        body: 'We keep customer records only as long as needed for service, warranty, and tax purposes, and we take reasonable steps to protect them from unauthorized access.',
      },
      {
        heading: 'Your choices',
        body: 'You may ask us to update or delete your information, or to stop contacting you, at any time by calling (346) 369-4236.',
      },
    ],
  },
  {
    id: 'terms',
    title: 'Terms of Service',
    updated: 'October 5, 2026',
    sections: [
      {
        heading: 'Free estimates',
        body: 'Estimates are provided free of charge and with no obligation. Prices are based on an on-site assessment and are valid for 30 days unless otherwise stated in writing.',
      },
      {
        heading: 'Scope of work',
        body: 'The work to be performed, materials, and price will be agreed upon before any project begins. Changes requested after approval may affect the final price and schedule, and will be confirmed with you first.',
      },
      {
        heading: 'Scheduling & weather',
        body: 'We make every effort to start and finish on the agreed dates. Weather, material availability, and site conditions may cause delays; we will keep you informed if your schedule changes.',
      },
      {
        heading: 'Payment',
        body: 'Payment terms, including any deposit for materials, will be stated on your estimate. Final payment is due upon completion of the work unless otherwise agreed in writing.',
      },
      {
        heading: 'Workmanship guarantee',
        body: 'We stand behind our work. If something isn’t right with the work we performed, contact us and we will inspect it and make it right. This guarantee does not cover damage caused by misuse, neglect, extreme weather, or third parties.',
      },
      {
        heading: 'Property access & utilities',
        body: 'You agree to provide safe access to the work area and to inform us of any known underground lines, irrigation, or hazards. We are not responsible for damage to unmarked private utilities.',
      },
      {
        heading: 'Contact',
        body: 'Questions about these terms? Call Dany Landscaping Stone Work at (346) 369-4236.',
      },
    ],
  },
];
